export default "__VITE_ASSET__CzXSHLR5__"